import { Navigate, Outlet } from 'react-router-dom';
import type { ReactElement } from 'react';
import { ROUTES } from '@/app/config/constants';
import { useAppSelector } from '@/app/store/hooks';
import { selectIsSupplierRole } from '@/features/authentication';

/**
 * The Supplier Bid Quotation is the Supplier role's BIDs (2026-10-27): any other role is sent to the buyer's BIDs,
 * which its own grant then decides. The other half of the gate, `BuyerBidsGate`, is the BIDs feature's.
 */
export function SupplierBidsGate(): ReactElement {
  const isSupplier = useAppSelector(selectIsSupplierRole);
  return isSupplier ? <Outlet /> : <Navigate to={ROUTES.RFQS} replace />;
}
